import React, { useEffect } from "react";
import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Home Page/Footer";
import "./Disclaimer.css"; // Reuse basic paragraph styles

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />
            <div className="container-fluid disclaimer-page posp-layout-padding">
                <div className="row">
                    <div className="col-12">
                        <h1>Contact Us</h1>

                        <p><strong>Registered & Corporate Office:</strong></p>
                        <p>
                            NO.33/54, <br />
                            Mount Poonamalee Road, <br />
                            Near Kathipara Flyover, <br />
                            St. Thomas Mount, <br />
                            Chennai - 600016
                        </p>

                        <p><strong>Support & Inquiries:</strong></p>
                        <p>
                            <strong>Phone:</strong> +917824077700<br />
                            <strong>Email:</strong> contact@vibeins.com
                        </p>

                        <p><strong>Principal Officer:</strong></p>
                        <p>Kameshwaran</p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Contact;
